import * as Popper from '@popperjs/core';
// Navigation functionality
export function initializeNavigation(): void {
  // Navbar scroll effect
  window.addEventListener('scroll', () => {
    const navbar = document.getElementById('navbar');
    if (navbar) {
      if (window.scrollY > 50) {
        navbar.classList.add('scrolled');
      } else {
        navbar.classList.remove('scrolled');
      }
    }
  });

  // Smooth scrolling for anchor links
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const href = (anchor as HTMLAnchorElement).getAttribute('href');
      if (!href) return;

      const target = document.querySelector(href);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    });
  });

  // hamburger menu for mobile nav

  const trigger = document.getElementById('navbar-menu-trigger');
  const menuContainer = document.getElementById('navbar-menu-container');
  const navbar = document.getElementById('navbar');
  const backdrop = document.getElementById('navbar-menu-backdrop');
  let menuPopper: Popper.Instance | undefined;
  let menuVisible = false;

  async function hideMenu(): Promise<void> {
    menuContainer?.removeAttribute('data-show');
    backdrop?.removeAttribute('data-show');
    await menuPopper?.update();
    menuVisible = false;
  }

  async function showMenu(): Promise<void> {
    menuContainer?.setAttribute('data-show', '');
    backdrop?.setAttribute('data-show', '');
    await menuPopper?.update();
    menuVisible = true;
  }

  if (trigger && menuContainer) {
    menuPopper = Popper.createPopper(navbar!, menuContainer, {
      modifiers: [
        {
          name: 'offset',
          options: {},
        },
      ],
    });
    trigger?.addEventListener('click', async () => {
      if (!menuVisible) {
        await showMenu();
      } else {
        await hideMenu();
      }
    });
    backdrop?.addEventListener('click', hideMenu);
    menuContainer.addEventListener('click', async (e) => {
      if (e.target instanceof HTMLAnchorElement) {
        await hideMenu();
      }
    });
  }
}

// Parallax effect on scroll
export function initializeParallax(): void {
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const parallax = document.querySelector('.hero-content') as HTMLElement;
    if (parallax) {
      parallax.style.transform = `translateY(${scrolled * 0.5}px)`;
      parallax.style.opacity = (1 - scrolled / 700).toString();
    }
  });
}

// Animate elements on scroll
export function initializeScrollAnimations(): void {
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -100px 0px',
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        (entry.target as HTMLElement).style.animation = 'fadeInUp 0.8s ease forwards';
      }
    });
  }, observerOptions);

  // Observe game cards and stats
  document.querySelectorAll('.game-card, .stat').forEach((el) => {
    observer.observe(el);
  });
}
